import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services-hero-section',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './services-hero-section.component.html',
  styleUrl: './services-hero-section.component.scss'
})
export class ServicesHeroSectionComponent {}
